import React, { memo, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import CollapsedMessage from '../../../components/collapsed-message/CollapsedMessage';
import CommonButton from '../../../components/common-button/CommonButton';
import CommonTextarea from '../../../components/common-textarea/CommonTextarea';
import { ID8_TABS } from '../../../constants';
import { changeEditableMessage, setEditableMessage, setIsDirty } from '../../../redux/id8/id8Reducer';
import CardMark from '../../../scout-new/components/message-card/CardMark';
import BackupActions from './BackupActions';
import CommonActions from './CommonActions';
import MessageText from './message-text/MessageText';

import scss from './MessageCard.module.scss';

const MessageCard = ({
  message: messageProps = {},
  onEditStart,
  isLoading,
  onSelect,
  onDelete,
  onInfo,
  onLike,
  onRestore,
  isActionsDisabled,
  onSaveMessage,
}) => {
  const { t } = useTranslation('id8');
  const dispatch = useDispatch();

  const { message, id, count, creator, newMessage } = messageProps;
  const editableMessage = useSelector((state) => state.id8.editableMessage);
  const id8Tab = useSelector((state) => state.id8.id8Tab);
  const [messageLocalText, setMessageLocalText] = useState(message);

  const isButtonsDisabled = isLoading || isActionsDisabled;

  const handleEditClose = () => {
    dispatch(setEditableMessage({ id: null, message: '' }));
    dispatch(setIsDirty(false));
    setMessageLocalText(message);
  };

  const handleChangeText = (newTextValue) => {
    setMessageLocalText(newTextValue);
    dispatch(changeEditableMessage(newTextValue));
  };

  const handleSaveTextChanges = () => {
    dispatch(onSaveMessage());
  };

  useEffect(() => {
    dispatch(setIsDirty(messageLocalText !== message));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [message, messageLocalText]);

  useEffect(() => {
    setMessageLocalText(message);
  }, [message]);

  return (
    <div className={scss.cardWrapper}>
      <div className={scss.leftContent}>
        <div className={scss.idCell}>{count}</div>

        <div className={scss.contentWrapper}>
          {editableMessage.id === id ? (
            <div className={scss.inputCell}>
              <CommonTextarea value={messageLocalText} onChange={handleChangeText} rows='3' />

              <div className={scss.inputCellActions}>
                <CommonButton styleColor='secondary' maxWidth={120} onClick={handleEditClose}>
                  {t('discard')}
                </CommonButton>

                <CommonButton styleColor='primary' maxWidth={120} onClick={handleSaveTextChanges}>
                  {t('saveChanges')}
                </CommonButton>
              </div>
            </div>
          ) : (
            <CollapsedMessage>
              <MessageText message={message} />
            </CollapsedMessage>
          )}
        </div>
      </div>
      {id8Tab === ID8_TABS.BACKUP ? (
        <BackupActions onRestore={onRestore} id={id} isDisabled={isButtonsDisabled} />
      ) : (
        <CommonActions
          onSelect={onSelect}
          onInfo={onInfo}
          onEditStart={onEditStart}
          onLike={onLike}
          onDelete={onDelete}
          isButtonsDisabled={isButtonsDisabled}
          messageProps={messageProps}
        />
      )}

      <CardMark isManual={creator === 'MANUAL'} isNew={newMessage} />
    </div>
  );
};

export default memo(MessageCard);
